module.exports = __webpack_public_path__ + "static/img/gglr1.ea3e399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/gglr1.png
// module id = ikXp
// module chunks = 0